import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	notification,
	Card,
	Result,
	Radio,
	Modal,
	Space,
	Grid,
} from 'antd';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import { Button, Input, Upload } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import {
	XThemeContainer,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeForm,
	XThemeSelect,
	XThemeRadio,
	XThemeModal,
	XThemeUploadButton,
	XEditButtonIcon,
} from '../../styles/GlobalThemeStyle';
import axios from 'axios';
import { UploadOutlined } from '@ant-design/icons';

import moment from 'moment';
import CaseSearch from '../../components/CaseSearch/CaseSearch';
// actions
import {
	getInsuranceCompaniesApi,
	getInsuranceCompaniesReset,
} from '../../actions/getInsuranceCompaniesAction';
import {
	addInsuranceCompanyApi,
	addInsuranceCompanyReset,
} from '../../actions/addInsuranceComapnyAction';
import {
	editInsuranceCompanyApi,
	editInsuranceCompanyReset,
} from '../../actions/editInsuranceCompanyAction';
import {
	deleteInsuranceCompanyApi,
	deleteInsuranceCompanyReset,
} from '../../actions/deleteInsuranceCompanyAction';
import {
	getStateDropdownApi,
	getStateDropdownReset,
} from '../../actions/getStateDropdownAction';
import {
	checkModulePermissions,
	getUserToken,
	urlPagination,
} from '../../utils/helper';
import { dateFilters } from '../../utils/constants';
import HeaderFile from '../../components/Header/HeaderFile';
import DataTable from '../../components/DataTable/DataTable';
import Header from '../../components/Header/Header';
import {
	filterByLabel,
	handleInputChange,
	lowerCaseInput,
	validateMobileNumber,
} from '../../utils/formFunctions';
import { getInsuranceCompanyByIdApi } from '../../actions/getInsuranceCompanyByIdAction';
import {
	getStatesListApi,
	getStatesListReset,
} from '../../actions/getStatesListAction';
import config from '../../config';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';
import { XTheme2InnerCard, XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';
const InsuranceCompany = (props) => {
	const {
		getInsuranceCompanies,
		getInsuranceCompaniesState,
		editInsuranceCompany,
		editInsuranceCompanyState,
		addInsuranceCompanyState,
		addInsuranceCompany,
		getInsuranceCompanyByIdState,
		getInsuranceCompanyById,
		addInsuranceCompanyReset,
		editInsuranceCompanyReset,
		deleteInsuranceCompany,
		deleteInsuranceCompanyState,
		deleteInsuranceCompanyReset,
		getStateDropdownState,
		getStateDropdown,
		getStatesList,
		getStatesListState,
	} = props;

	const navigate = useNavigate();
	const defaultFilters = {
		search: '',
		page: 1,
		sort: 'updatedAt',
		sortDirection: 'descend',
		created_on: 'all',
		functional_in_states: [],
		hq_state: '',
		limit: 10,
	};
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');
	const [modalOpen, setModalOpen] = useState([false, '']);
	const [editCompanyActive, setEditCompanyActive] = useState(false);
	let modulePermissions = checkModulePermissions(
		'insurance-company-management',
	);

	const [form] = XThemeForm.useForm();
	const [form2] = XThemeForm.useForm();
	const [formData, setFormData] = useState({});
	const [fileChanged, setFileChanged] = useState(false);
	const [open, setOpen] = useState(false);
	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setFileList([]);
		setFileChanged(false);
		setOpen(false);
	};

	const onChangeFilters = (key) => {
		setFilters({
			...filters,
			[key.target.name]: key.target.value,
		});
	};

	const columns = [
		{
			title: 'Name',
			width: 200,
			dataIndex: 'name',
			fixed: 'left',
			render: (name) => (
				<div>
					<div>{name}</div>
				</div>
			),
		},
		{
			title: 'Email Address',
			width: 200,
			dataIndex: 'contact_person_email_address',
			render: (contact_person_email_address) => (
				<div>
					<div>{contact_person_email_address}</div>
				</div>
			),
		},
		{
			title: 'Mobile Number',
			width: 200,
			dataIndex: 'contact_person_mobile_number',
			render: (contact_person_mobile_number) => (
				<div>
					<div>{contact_person_mobile_number}</div>
				</div>
			),
		},
		{
			title: 'Fax Number',
			width: 150,
			dataIndex: 'fax_number',
			render: (fax_number) => (
				<div>
					<div>{fax_number}</div>
				</div>
			),
		},
		{
			title: 'HQ Address',
			width: 300,
			dataIndex: 'address',
			render: (address) => (
				<div>
					<div>{address}</div>
				</div>
			),
		},
		{
			title: 'HQ State',
			width: 150,
			dataIndex: 'hq_state',
			render: (hq_state) => (
				<div>
					<div>{hq_state}</div>
				</div>
			),
		},
		{
			title: 'Pincode',
			width: 150,
			dataIndex: 'pincode',
			render: (pincode) => (
				<div>
					<div>{pincode}</div>
				</div>
			),
		},
		{
			title: 'City',
			width: 150,
			dataIndex: 'city',
			render: (city) => (
				<div>
					<div>{city}</div>
				</div>
			),
		},
		{
			title: 'Last Updated Date',
			width: 200,
			dataIndex: 'updatedAt',
			sorter: (a, b) => a.updatedAt - b.updatedAt,
			sortDirections: ['ascend', 'descend'],
			render: (updatedAt) => (
				<div>
					<div>{updatedAt}</div>
				</div>
			),
		},
		{
			title: 'Action',
			width: 150,
			dataIndex: 'action',
			fixed: 'right',
		},
	];

	const showDeleteConfirm = (_id, name) => {
		XThemeModal.confirm({
			title: 'Delete Insurance Company?',
			content: (
				<p className="modalPara1">
					Are you sure you want to delete {name}?
				</p>
			),
			icon: <img className="me-3" src="/images/delete-icon.svg" alt="" />,
			okText: 'Yes, Confirm',
			okType: 'danger',
			cancelText: 'No, Cancel',
			className: 'confirmModal',
			cancelButtonProps: {
				className: 'xThemeCancelSubmit',
			},
			okButtonProps: {
				className: 'xThemeButtonSubmit',
			},
			onOk() {
				deleteInsuranceCompany({ id: _id });
			},
			onCancel() {
				console.log('Cancel');
			},
		});
	};

	const handleEdit = (item) => {
		navigate(`/insurance-company/edit/${item._id}`);
		// old code
		// setEditCompanyActive(true);

		// setFormData({
		// 	_id: item._id,
		// });

		// setModalOpen([true, `Edit Insurance Company`]);
		// getInsuranceCompanyById({
		// 	id: item._id,
		// });
	};

	const handleState = (name, value) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};
	// use effects

	useEffect(() => {
		if (getInsuranceCompaniesState.apiState === 'success') {
			if (getInsuranceCompaniesState.data.insurances.length > 0) {
				const updatedData = [];
				const updatedSearchOptions = [];
				setTotalRecords(getInsuranceCompaniesState.data.total_count);
				getInsuranceCompaniesState.data.insurances.map(
					(item, index) => {
						updatedSearchOptions.push({ value: item.name });
						updatedData.push({
							key: item._id,
							_id: item._id,
							name: item.name,
							contact_person_email_address:
								item.contact_person_email_address,
							contact_person_mobile_number:
								item.contact_person_mobile_number,
							fax_number: item.fax_number,
							address: item.address,
							hq_state: item.hq_state,
							pincode: item.pincode,
							city: item.city,
							updatedAt: (
								<div className="showDate">
									{moment(item.updatedAt).format(
										'DD-MM-YYYY',
									)}
								</div>
							),
							action: (
								<div className="text-center">
									<Row>
										<Col xs={{ span: 6, offset: 6 }}>
											{modulePermissions.sub_modules.includes(
												'view-insurance-companies',
											) && (
												<XEditButtonIcon
													onClick={() => {
														handleEdit(item);
													}}
													type="text"
												>
													<img
														src="./images/pencil.svg"
														alt=""
													/>
												</XEditButtonIcon>
											)}
										</Col>
										<Col xs={{ span: 9, offset: 3 }}>
											{modulePermissions.sub_modules.includes(
												'delete-insurance-companies',
											) && (
												<XEditButtonIcon
													className="hasIconColor"
													onClick={() =>
														showDeleteConfirm(
															item._id,
															item.name,
														)
													}
													type="text"
												>
													<img
														src="./images/delete-icon-card.svg"
														alt=""
													/>
												</XEditButtonIcon>
											)}
										</Col>
									</Row>
								</div>
							),
						});
					},
				);
				setTableData(updatedData);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
		}
	}, [getInsuranceCompaniesState]);

	useEffect(() => {
		if (getInsuranceCompanyByIdState.apiState === 'success') {
			setFormData({
				id: getInsuranceCompanyByIdState.data._id,
				name: getInsuranceCompanyByIdState.data.name,
				contact_person_email_address:
					getInsuranceCompanyByIdState.data
						.contact_person_email_address,
				contact_person_mobile_number:
					getInsuranceCompanyByIdState.data
						.contact_person_mobile_number,
				fax_number: getInsuranceCompanyByIdState.data.fax_number,
				address: getInsuranceCompanyByIdState.data.address,
				functional_in_states:
					getInsuranceCompanyByIdState.data.functional_in_states,
				hq_state: getInsuranceCompanyByIdState.data.hq_state,
				pincode: getInsuranceCompanyByIdState.data.pincode,
				city: getInsuranceCompanyByIdState.data.city,
				updatedAt: getInsuranceCompanyByIdState.data.updatedAt,
			});
			form.setFieldsValue({
				id: getInsuranceCompanyByIdState.data._id,
				name: getInsuranceCompanyByIdState.data.name,
				contact_person_email_address:
					getInsuranceCompanyByIdState.data
						.contact_person_email_address,
				contact_person_mobile_number:
					getInsuranceCompanyByIdState.data
						.contact_person_mobile_number,
				fax_number: getInsuranceCompanyByIdState.data.fax_number,
				address: getInsuranceCompanyByIdState.data.address,
				functional_in_states:
					getInsuranceCompanyByIdState.data.functional_in_states,
				hq_state: getInsuranceCompanyByIdState.data.hq_state,

				pincode: getInsuranceCompanyByIdState.data.pincode,
				city: getInsuranceCompanyByIdState.data.city,
				updatedAt: getInsuranceCompanyByIdState.data.updatedAt,
			});
			if (getInsuranceCompanyByIdState.data.logo)
				setFileList([getInsuranceCompanyByIdState.data.logo]);
		}
	}, [getInsuranceCompanyByIdState]);

	useEffect(() => {
		if (editInsuranceCompanyState.apiState === 'success') {
			form.resetFields();
			setFormData({});
			setFileList([]);
			setFileChanged(false);

			editInsuranceCompanyReset();
			getInsuranceCompanies();
			notification.success({
				message: editInsuranceCompanyState.message,
			});
			setModalOpen([false, '']);
		} else if (editInsuranceCompanyState.apiState === 'error') {
			notification.error({
				message: editInsuranceCompanyState.message,
			});
			editInsuranceCompanyReset();
		}
	}, [editInsuranceCompanyState]);

	useEffect(() => {
		if (addInsuranceCompanyState.apiState === 'success') {
			form.resetFields();
			setFormData({});
			setFileList([]);
			setFileChanged(false);

			addInsuranceCompanyReset();
			getInsuranceCompanies();
			notification.success({
				message: addInsuranceCompanyState.message,
			});
			setModalOpen([false, '']);
		} else if (addInsuranceCompanyState.apiState === 'error') {
			notification.error({
				message: 'Error is adding Provider.',
			});
			addInsuranceCompanyReset();
		}
	}, [addInsuranceCompanyState]);

	useEffect(() => {
		if (deleteInsuranceCompanyState.apiState === 'success') {
			deleteInsuranceCompanyReset();
			getInsuranceCompanies();
		}
	}, [deleteInsuranceCompanyState]);

	const applyFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through filters and update the query parameters
		Object.entries(filters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the current value
				queryParams.append(key, value);
			}
		});

		// Set the page to 1
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');
		filters.page = 1;

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });

		// Make API call with updated filters and pagination
		checkModulePermissions(
			'insurance-company-management',
		).sub_modules.includes('list-insurance-companies') &&
			getInsuranceCompanies({ ...updatedFilters });
	}, [window.location.search]);

	const clearFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through defaultFilters and update the query parameters
		Object.entries(defaultFilters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the default value
				queryParams.append(key, value);
			}
		});

		// Clear the form fields
		form2.resetFields();

		// Update the state with default values
		setFilters(defaultFilters);

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	const [fileList, setFileList] = useState([]);
	const handleChange = (info) => {
		let newFileList = [...info.fileList];

		// 1. Limit the number of uploaded files
		// Only to show two recent uploaded files, and old ones will be replaced by the new
		newFileList = newFileList.slice(-2);

		// 2. Read from response and show file link
		newFileList = newFileList.map((file) => {
			if (file.response) {
				// Component will show file.url as link
				file.url = file.response.url;
				return { ...file, status: 'done' };
			}
			return file;
		});
		setFileChanged(true);
		setFileList(newFileList);
	};

	const handleSubmit = async () => {
		try {
			let newFile = {};
			await form.validateFields(); // Wait for form validation

			if (fileList.length > 0 && fileChanged) {
				await Promise.all(
					fileList.map(async (fileData) => {
						let get_ext = fileData.originFileObj.name.split('.');
						let ext = get_ext[get_ext.length - 1];
						const res = await axios.get(
							`${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=insurance_companies&file_name=${formData.name}&ext=${ext}&id=${fileData.originFileObj.uid}`,
							{
								headers: {
									'Content-type':
										'application/json; charset=UTF-8',
									Authorization: 'Bearer ' + getUserToken(),
								},
							},
						);

						const result = await axios.put(
							res.data.data,
							fileData.originFileObj,
						);

						if (result.status === 200) {
							const documentPath = `/insurance_companies/${fileData.originFileObj.uid}/${formData.name}.${ext}`;
							newFile = {
								uid: fileData.originFileObj.uid,
								name: fileData.originFileObj.name,
								status: 'done',
								url: documentPath,
							};
						}
					}),
				);
				console.log('Files Uploaded');
			}

			if (formData.id) {
				await editInsuranceCompany({
					...formData,
					...(fileChanged
						? { logo: newFile }
						: { logo: fileList[0] }),
				});
			} else {
				await addInsuranceCompany({
					...formData,
					...(fileChanged
						? { logo: newFile }
						: { logo: fileList[0] }),
				});
			}
		} catch (error) {
			// Handle error if any
			notification.error({
				message: 'An error occurred',
			});
			console.error('Error occurred:', error);
		}
	};
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Insurance Company" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="insuranceCompany" />
					</Col>
				</>
			)}
			<XThemeContainer fluid>
				{checkModulePermissions(
					'insurance-company-management',
				).sub_modules.includes('list-insurance-companies') ? (
					<>
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									Insurance Company Management
								</XTheme2MainTitle>
								<XTheme2Para1>
									View and manage insurance companies
								</XTheme2Para1>
							</Col>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-end"
							>
								{isMobile ? (
									<XTheme2Button
										shape="circle"
										size="large"
										className="noBackground borderColor"
										onClick={() => {
											navigate('/insurance-company/add');
										}}
										icon={<PlusOutlined />}
									/>
								) : (
									<Link to="/insurance-company/add">
										<XTheme2Button
											size="large"
											icon={<PlusOutlined />}
										>
											Add Insurance Company
										</XTheme2Button>
									</Link>
								)}
							</Col>
						</Row>

						<XTheme2InnerCard
							className="mb-3"
							bodyStyle={{ padding: '20px 0px' }}
						>
							<div className="smallTopBottomPadding mb-3 px-4">
								<CaseSearch
									filters={[
										<XThemeForm.Item
											name="hq_state"
											colon={false}
											label="HQ State"
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												allowClear
												className="noBorderRadius"
												placeholder="Select State"
												defaultValue={
													filters.hq_state
														? filters.hq_state
														: null
												}
												onFocus={() => {
													getStatesList();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getStatesList({
															search,
														});
													} else if (
														search.length === 0
													) {
														getStatesList();
													}
												}}
												onClear={() => {
													setFilters({
														...filters,
														hq_state: '',
														insurance_company: '',
													});
												}}
												showSearch={true}
												filterOption={filterByLabel}
												options={
													getStatesListState.apiState ===
														'success' &&
													getStatesListState.data
														.all_states?.length >
														0 &&
													getStatesListState.data.all_states.map(
														(itm) => {
															return {
																label: itm.state,
																value: itm.state,
																providers:
																	itm.providers,
															};
														},
													)
												}
												onSelect={(value, options) => {
													setFilters({
														...filters,
														hq_state: value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="functional_in_states"
											colon={false}
											label="Functional in States"
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												allowClear
												mode="multiple"
												maxTagCount={(3, 'responsive')}
												showSearch={true}
												className="noBorderRadius"
												placeholder="Select States"
												defaultValue={
													filters.functional_in_states
														? filters.functional_in_states
														: null
												}
												onFocus={() => {
													getStateDropdown();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getStateDropdown({
															search,
														});
													} else if (
														search.length === 0
													) {
														getStateDropdown();
													}
												}}
												onClear={() => {
													setFilters({
														...filters,
														functional_in_states:
															'',
													});
												}}
												filterOption={filterByLabel}
												options={
													getStateDropdownState.apiState ===
														'success' &&
													getStateDropdownState.data
														.all_states?.length >
														0 &&
													getStateDropdownState.data.all_states.map(
														(itm) => {
															return {
																label: itm.state,
																value: itm.state,
																providers:
																	itm.providers,
															};
														},
													)
												}
												onChange={(value, options) => {
													setFilters({
														...filters,
														functional_in_states:
															value,
													});
												}}
											/>
										</XThemeForm.Item>,

										<XThemeForm.Item
											name="created_on"
											colon={false}
											label="Date Within"
											className="drawerlabel"
										>
											<XThemeRadio.Group
												onChange={onChangeFilters}
												name="created_on"
												defaultValue={
													filters.created_on
														? filters.created_on
														: null
												}
											>
												<Row>
													{dateFilters.map(
														(item, index) => (
															<Col
																xs={12}
																lg={12}
																md={12}
																xl={12}
															>
																<XThemeRadio
																	value={
																		item.value
																	}
																>
																	{item.label}
																</XThemeRadio>
															</Col>
														),
													)}
												</Row>
											</XThemeRadio.Group>
										</XThemeForm.Item>,
									]}
									onClose={onClose}
									open={open}
									applyFilters={applyFilters}
									form={form2}
									clearFilters={clearFilters}
								/>
								<Row
									gutter={(15, 15)}
									className="align-items-center"
								>
									<Col xs={16} sm={24} md={6} lg={4}>
										<h1
											className="cardTitle mb-0"
											style={{ fontSize: '18px' }}
										>
											Total {totalRecords} Companies
										</h1>
									</Col>
									<Col
										xs={24}
										sm={16}
										md={12}
										lg={12}
										className="d-none d-md-block"
									>
										<Space>
											<XTheme2InputText
												size="large"
												allowClear
												placeholder="Search for Insurance Companies"
												defaultValue={
													filters.search
														? filters.search
														: null
												}
												onChange={(v) => {
													if (v.target.value === '') {
														urlPagination(
															filters,
															'search',
															'',
														);
														setFilters({
															...filters,
															search: '',
														});
													} else {
														setFilters({
															...filters,
															search: v.target
																.value,
														});
													}
												}}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														const searchValue =
															filters.search
																? filters.search
																: '';
														if (searchValue) {
															urlPagination(
																filters,
																'search',
																searchValue,
															);
															setFilters({
																...filters,
																search: searchValue,
															});
														}
													}
												}}
											/>
											<XTheme2Button
												onClick={() => {
													// Trigger search when the button is clicked
													const searchValue =
														filters.search
															? filters.search
															: '';
													if (searchValue) {
														urlPagination(
															filters,
															'search',
															searchValue,
														);
														setFilters({
															...filters,
															search: searchValue,
														});
													}
												}}
											>
												Search
											</XTheme2Button>
										</Space>
									</Col>
									<Col
										xs={8}
										sm={8}
										md={6}
										lg={8}
										className="text-end"
									>
										<Space>
											<XTheme2Button
												className="noBackground borderColor"
												shape="circle"
												size="large"
												onClick={() => showDrawer()}
												icon={
													<img
														src="/images/theme-filter-icon.svg"
														alt="filter"
													/>
												}
											/>
											{/* <XThemeFilterButton
											className="backgroundRevers"
											onClick={() => {
												navigate(
													'/insurance-company/add',
												);
											}}
											icon={<PlusCircleFilled />}
										>
											Insurance Company
										</XThemeFilterButton> */}
										</Space>
									</Col>
								</Row>
							</div>

							<DataTable
								tableData={tableData}
								columns={columns}
								totalRecords={totalRecords}
								setFilters={setFilters}
								filters={filters}
								state={getInsuranceCompaniesState.apiState}
								page={'insurance-company'}
								handleEdit={handleEdit}
								showDeleteConfirm={showDeleteConfirm}
							/>
						</XTheme2InnerCard>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>

			<XThemeModal
				title={modalOpen[1]}
				centered
				open={modalOpen[0]}
				onCancel={() => {
					form.resetFields();
					setFormData({});
					setFileList([]);
					setFileChanged(false);
					setModalOpen([false, '']);
				}}
				footer={null}
				okButtonProps={{ style: { display: 'none' } }}
				cancelButtonProps={{ style: { display: 'none' } }}
				width={850}
			>
				<XThemeForm
					form={form}
					name="roleForm"
					layout="vertical"
					autoComplete="off"
					onFinish={() => {
						// editCompanyActive
						// 	? updateInsuranceComapnySubmit()
						// 	: addInsuranceComapnySubmit();
						handleSubmit();
					}}
				>
					<Row gutter={(15, 15)} className="mt-4">
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								className="drawerlabel"
								name="name"
								label="Name"
								rules={[
									{
										required: true,
										message: 'Please enter Company name',
									},
								]}
							>
								<XThemeInputText
									className="noBorderRadius"
									size="large"
									placeholder="Enter Company Name"
									name="name"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								className="drawerlabel"
								name="contact_person_email_address"
								label="Contact Person Email Address"
								rules={[
									{
										type: 'email',
										message:
											'Please enter a valid email address',
									},
								]}
							>
								<XThemeInputText
									className="noBorderRadius"
									size="large"
									placeholder="Enter Contact Person Email Address"
									name="contact_person_email_address"
									onInput={lowerCaseInput}
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								className="drawerlabel"
								name="contact_person_mobile_number"
								label="Contact Person Mobile Number"
								rules={[
									{
										validator: validateMobileNumber,
									},
								]}
							>
								<XThemeInputText
									className="noBorderRadius"
									size="large"
									placeholder="Enter Contact Person Mobile Number"
									name="contact_person_mobile_number"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								className="drawerlabel"
								name="fax_number"
								label="Fax Number"
							>
								<XThemeInputText
									className="noBorderRadius"
									size="large"
									placeholder="Enter Fax Number"
									name="fax_number"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								className="uploadButton drawerlabel"
								name="logo"
								label="Logo"
								rules={[
									{
										required: true,
										message: 'Please Add Logo',
									},
								]}
							>
								<Upload
									size="large"
									fileList={fileList}
									onChange={handleChange}
									multiple={false}
									maxCount={1}
								>
									<XThemeUploadButton
										icon={<UploadOutlined />}
										size="large"
									>
										Upload
									</XThemeUploadButton>
								</Upload>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								name="address"
								label="Address"
								className="textAreaStyle drawerlabel"
							>
								<XThemeInputText.TextArea
									size="large"
									placeholder="Enter Address"
									name="address"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								name="hq_state"
								label={'HQ State'}
								className="drawerlabel"
							>
								<XThemeSelect
									className="noBorderRadius"
									size="large"
									placeholder="Select State"
									name="hq_state"
									showSearch={true}
									defaultValue={formData.hq_state}
									onFocus={() => {
										getStatesList();
									}}
									onSearch={(search) => {
										if (search.length >= 3) {
											getStatesList({
												search,
											});
										} else if (search.length === 0) {
											getStatesList();
										}
									}}
									filterOption={filterByLabel}
									options={
										getStatesListState.apiState ===
											'success' &&
										getStatesListState.data.all_states
											?.length > 0 &&
										getStatesListState.data.all_states.map(
											(itm) => {
												return {
													label: itm.state,
													value: itm.state,
													providers: itm.providers,
												};
											},
										)
									}
									onChange={(value, options) => {
										handleState('hq_state', value);
									}}
								/>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								name="functional_in_states"
								label={'Functional In States'}
								className="drawerlabel"
							>
								<XThemeSelect
									className="noBorderRadius"
									size="large"
									mode="multiple"
									placeholder="Select States"
									name="functional_in_states"
									maxTagCount={(3, 'responsive')}
									showSearch={true}
									defaultValue={formData.functional_in_states}
									onFocus={() => {
										getStatesList();
									}}
									onSearch={(search) => {
										if (search.length >= 3) {
											getStatesList({
												search,
											});
										} else if (search.length === 0) {
											getStatesList();
										}
									}}
									filterOption={filterByLabel}
									options={
										getStatesListState.apiState ===
											'success' &&
										getStatesListState.data.all_states
											?.length > 0 &&
										getStatesListState.data.all_states.map(
											(itm) => {
												return {
													label: itm.state,
													value: itm.state,
													providers: itm.providers,
												};
											},
										)
									}
									onChange={(value, options) => {
										// handleInputChange(
										// 	value,
										// 	formData,
										// 	setFormData,
										// );
										handleState(
											'functional_in_states',
											value,
										);
									}}
								/>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								name="pincode"
								label="Pincode"
								className="drawerlabel"
							>
								<XThemeInputText
									className="noBorderRadius"
									size="large"
									placeholder="Enter Pincode"
									name="pincode"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							<XThemeForm.Item
								name="city"
								label="City"
								className="drawerlabel"
							>
								<XThemeInputText
									className="noBorderRadius"
									size="large"
									placeholder="Enter City"
									name="city"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XThemeForm.Item>
						</Col>
						<Col xs={24} lg={12}>
							{/* <XThemeForm.Item className="text-right mt-3">
								<XShareButton
									style={{
										background: '#fff',
										margin: 0,
										color: '#007299',
									}}
									size="large"
									onClick={() => {
										form.resetFields();
										setFormData({});
										setModalOpen([false, '']);
									}}
								>
									Cancel
								</XShareButton>
							</XThemeForm.Item> */}
						</Col>
						<Col xs={24} className="text-center text-sm-end">
							<Space>
								<XThemeFilterButton
									size="large"
									onClick={() => {
										form.resetFields();
										setFormData({});
										setModalOpen([false, '']);
									}}
								>
									Cancel
								</XThemeFilterButton>
								<XThemeFilterButton
									className="backgroundRevers"
									htmlType="submit"
									size="large"
									disabled={
										(editCompanyActive &&
											!modulePermissions.sub_modules.includes(
												'update-insurance-companies',
											)) ||
										!modulePermissions.sub_modules.includes(
											'add-insurance-companies',
										)
									}
								>
									Submit
								</XThemeFilterButton>
							</Space>
						</Col>
					</Row>
				</XThemeForm>
			</XThemeModal>
		</>
	);
};

const mapStateToProps = (state) => ({
	getInsuranceCompaniesState: state.getInsuranceCompanies,
	addInsuranceCompanyState: state.addInsuranceCompany,
	editInsuranceCompanyState: state.editInsuranceCompany,
	getInsuranceCompanyByIdState: state.getInsuranceCompanyById,
	deleteInsuranceCompanyByIdState: state.deleteInsuranceCompanyById,
	deleteInsuranceCompanyState: state.deleteInsuranceCompany,
	getStateDropdownState: state.getStateDropdown,
	getStatesListState: state.getStatesList,
});

const mapDispatchToProps = (dispatch) => ({
	getInsuranceCompanies: (data) => dispatch(getInsuranceCompaniesApi(data)),
	addInsuranceCompany: (data) => dispatch(addInsuranceCompanyApi(data)),
	editInsuranceCompany: (data) => dispatch(editInsuranceCompanyApi(data)),
	getInsuranceCompanyById: (data) =>
		dispatch(getInsuranceCompanyByIdApi(data)),
	deleteInsuranceCompany: (data) => dispatch(deleteInsuranceCompanyApi(data)),
	getInsuranceCompaniesReset: () => dispatch(getInsuranceCompaniesReset()),
	addInsuranceCompanyReset: () => dispatch(addInsuranceCompanyReset()),
	editInsuranceCompanyReset: () => dispatch(editInsuranceCompanyReset()),
	deleteInsuranceCompanyReset: () => dispatch(deleteInsuranceCompanyReset()),
	getStateDropdown: (params) => dispatch(getStateDropdownApi(params)),
	getStatesList: (params) => dispatch(getStatesListApi(params)),
	getStateDropdownReset: () => dispatch(getStateDropdownReset()),
	getStatesListReset: () => dispatch(getStatesListReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceCompany);
